(function() {
  'use strict';

  angular
    .module('evenstrangerthings', ['ngRoute', 'ngFileUpload']);

})();

(function () {
    'use strict';

    angular
        .module('evenstrangerthings')
        .directive('showImageLabels', showImageLabels);

    /** @ngInject */
    function showImageLabels() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/showImageLabels/showImageLabels.html',
            scope: {
                renderToCanvas: '=',
                imageLabels: '='
            },
            controller: ShowImageLabelsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ShowImageLabelsController($window, $scope, $log) {

            var vm = this;
            var i = 0;
            var speed = 50;
            var typewriter = document.getElementById("typewriter");
            var timeoutID;

            $scope.$watch('vm.renderToCanvas', function (ready) {

                i = 0;
                vm.renderToCanvas = false;
                typewriter.innerHTML = '';

                if (ready) {

                    // $log.log(vm.imageLabels);

                    var labels = vm.imageLabels.map(function(item) {
                        return item.description;
                    })

                    var output = "I saw: " + labels.join(', ');

                    function typeWriter() {

                        if (i < output.length) {
                            typewriter.innerHTML += output.charAt(i);
                            i++;
                            timeoutID = $window.setTimeout(typeWriter, speed);
                        } else {
                            $window.clearTimeout(timeoutID);
                        }
                    }

                    typeWriter();

                }
            })
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('evenstrangerthings')
        .directive('strangerCanvas', strangerCanvas);

    /** @ngInject */
    function strangerCanvas() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/strangerCanvas/strangerCanvas.html',
            scope: {
                renderToCanvas: '=',
                userImage: '=',
                userText: '=',
                displayWidth: '='
            },
            controller: StrangerCanvasController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function StrangerCanvasController($scope) {

            var vm = this;
            var canvas = document.getElementById('preview');
            var ctx = canvas.getContext('2d');

            $scope.$watch('vm.renderToCanvas', function (ready) {

                if (ready) {
                    drawFinalImage(vm.userImage, vm.displayWidth);
                    drawTextOnCanvas(vm.userText);
                }

                vm.renderToCanvas = false;
            });

            function drawTextOnCanvas(text) {

                var fontSize = fitTextOnCanvas(text, 491);
                var lighting = document.getElementById('lighting-small');

                ctx.textBaseline = 'top';
                ctx.shadowColor = 'rgba(215,21,0, 1)';
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
                ctx.shadowBlur = 7;
                ctx.font = fontSize + 'px Benguiat';
                ctx.lineWidth = 2;
                ctx.strokeStyle = 'rgb(255,0,7)';
                ctx.strokeText(text, 254, 805);
                ctx.shadowBlur = 5;
                ctx.strokeText(text, 254, 805);

                ctx.shadowBlur = 0;
                ctx.globalAlpha = 0.6;
                ctx.globalCompositeOperation = 'multiply';
                ctx.drawImage(lighting, 54, 574, 853, 568);

            }

            function fitTextOnCanvas(text, width) {

                // start with a large font size
                var fontSize = 300;

                // lower the font size until the text fits the canvas
                do {
                    fontSize--;
                    ctx.font = fontSize + 'px Benguiat';
                } while (ctx.measureText(text).width > width)

                // draw the text
                ctx.fillText(text, 0, 0);

                return fontSize;

            }

            function drawFinalImage(imageToDisplay, displayWidth) {

                var yc = document.createElement('canvas');
                var yctx = yc.getContext('2d');

                var background = document.getElementById('canvas-background');
                var mask = document.getElementById('mask');

                canvas.width = displayWidth;
                canvas.height = displayWidth;

                yc.width = displayWidth;
                yc.height = displayWidth;

                yctx.drawImage(mask, 0, 0, displayWidth, displayWidth);
                yctx.globalCompositeOperation = 'source-in';

                drawImageProp(yctx, imageToDisplay, 0, 0, displayWidth, displayWidth);

                ctx.drawImage(background, 0, 0, displayWidth, displayWidth);

                ctx.globalCompositeOperation = 'overlay';
                ctx.drawImage(yc, 0, 0, displayWidth, displayWidth);

                ctx.globalCompositeOperation = 'normal';


            }

            /**
             * By Ken Fyrstenberg Nilsen
             *
             * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
             *
             * If image and context are only arguments rectangle will equal canvas
            */
            function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

                if (arguments.length === 2) {
                    x = y = 0;
                    w = ctx.canvas.width;
                    h = ctx.canvas.height;
                }

                // default offset is center
                offsetX = angular.isNumber(offsetX) ? offsetX : 0.5;
                offsetY = angular.isNumber(offsetY) ? offsetY : 0.5;

                // keep bounds [0.0, 1.0]
                if (offsetX < 0) offsetX = 0;
                if (offsetY < 0) offsetY = 0;
                if (offsetX > 1) offsetX = 1;
                if (offsetY > 1) offsetY = 1;

                var iw = img.width,
                    ih = img.height,
                    r = Math.min(w / iw, h / ih),
                    nw = iw * r,   // new prop. width
                    nh = ih * r,   // new prop. height
                    cx, cy, cw, ch, ar = 1;

                // decide which gap to fill
                if (nw < w) ar = w / nw;
                if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
                nw *= ar;
                nh *= ar;

                // calc source rectangle
                cw = iw / (nw / w);
                ch = ih / (nh / h);

                cx = (iw - cw) * offsetX;
                cy = (ih - ch) * offsetY;

                // make sure source rectangle is valid
                if (cx < 0) cx = 0;
                if (cy < 0) cy = 0;
                if (cw > iw) cw = iw;
                if (ch > ih) ch = ih;

                // fill image in dest. rectangle
                ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
            }

        }
    }

})();

(function() {
  'use strict';

  angular
    .module('evenstrangerthings')
    .directive('spinner', spinner);

  /** @ngInject */
  function spinner() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/spinner/spinner.html',
      scope: {
          creationDate: '='
      },
      controller: SpinnerController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SpinnerController() {
      var vm = this;

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('evenstrangerthings')
    .factory('Helpers', Helpers);

  /** @ngInject */
  function Helpers($log) {

    // correct rotation of user image by temporarily 
    // rendering as an image element (thereby using 
    // browser to correct on EXIF data)

    function loadImage(file, callback) {
      var image = document.createElement('img');
      image.onload = function () {
        URL.revokeObjectURL(image.src);
        callback(image);
      };
      image.onerror = function () {
        URL.revokeObjectURL(image.src);
        $log.log('Incorrect image format.');
      };
      image.src = file;
    }

    function correctImage(file, callback) {
      loadImage(file, function (image) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0, image.width, image.height);
        try {
          // var correctedData = canvas.toDataURL('image/jpeg', 1.0);
          callback(canvas);
        } catch (e) {
          $log.log('Save image error.');
          $log.log(e);
        }
      });
    }

    return {
      correctImageRotation: function (image, callback) {

        correctImage(image, function (data) {

          callback(data);

        });

      },

      // proportionally resize canvas element to desired width 

      resizeCanvas: function (canvas, desiredWidth) {
        var resized = document.createElement('canvas');
        var ctx = resized.getContext('2d');

        var ratio = canvas.width / canvas.height;
        var newHeight = desiredWidth / ratio;

        resized.width = desiredWidth;
        resized.height = newHeight;

        ctx.drawImage(canvas, 0, 0, desiredWidth, newHeight);
        return resized;
      }

    }

  }

})();

(function() {
  'use strict';

  // return an environment variable and url

  angular
    .module('evenstrangerthings')
    .factory('Environment', Environment);

  /** @ngInject */
  function Environment($log, $location) {

    var path;
    var host = $location.host();

    switch(host)
    {
      case 'localhost' :
        path = "http://127.0.0.1:5001/even-stranger-things/us-central1/getImageAnnotations";
        break;

      default :
        path = "https://us-central1-even-stranger-things.cloudfunctions.net/getImageAnnotations";
      break;
    }

    var environment = {
      'mode':'production',
      'apiURL':path,

    };

    return environment;

  }

})();

(function() {
  'use strict';

  // return an environment variable and url

  angular
    .module('evenstrangerthings')
    .factory('Api', Api);

  /** @ngInject */
  function Api($log, $http, Environment) {

    var ENV = Environment.apiURL;

    return {
      postImage: function (image) {

        return $http.post(ENV + '/describe-image', {
          image: image
        });

      }

    };

  }

})();

(function () {
  'use strict';

  angular
    .module('evenstrangerthings')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $window, $log, Api, Helpers) {

    var vm = this;
    var UPLOAD_WIDTH = 650;

    vm.gotResponse = false;
    vm.loading = false;
    vm.allAssetsLoaded = false;
    vm.renderToCanvas = false;
    vm.userText = null;
    vm.userImage = null;
    vm.displayWidth = 1000;
    vm.showCanvas = false;  
    vm.imageLabels = null;  

    preloadAssets();

    vm.upload = function (file) {

      vm.loading = true;
      vm.gotResponse = false;
      vm.success = false;

      var img = new Image();
      var reader = new FileReader();

      reader.onload = function (event) {
        img.onload = function () {
          // correct the image orientation of the user image
          Helpers.correctImageRotation(img.src, function (correctedImage) {
            resizeImage(correctedImage);
          });
        }
        img.src = event.target.result;
      }

      if (file != null) {
        reader.readAsDataURL(file);
      }

    };

    vm.goAgain = function () {

      vm.showCanvas = false;

    }

    function preloadAssets() {

      var manifest = [
        'assets/images/tv.png',
        'assets/images/upload-an-image.png',
        'assets/images/loading.gif',
        'assets/images/canvas-placeholder.png',
        'assets/images/canvas-background.png',
        'assets/images/mask.png',
        'assets/images/lighting-small.png'
      ];

      var preload = new createjs.LoadQueue(true, '/');

      preload.on('complete', imagesLoaded);
      preload.loadManifest(manifest, true, "/");

    }

    function imagesLoaded() {

      $scope.$apply(function () {
        vm.allAssetsLoaded = true;
      });

    }

    function resizeImage(correctedImage) {

      $scope.$apply(function () {

        // upload a lower res version of image to cloud vision api
        var imageToUpload = Helpers.resizeCanvas(correctedImage, UPLOAD_WIDTH);
        // resize user image for display on canvas
        var imageToDisplay = Helpers.resizeCanvas(correctedImage, vm.displayWidth);

        getImageLabels(imageToUpload, imageToDisplay);

      });

    }

    function getImageLabels(imageToUpload, imageToDisplay) {

      var postImage = imageToUpload.toDataURL('image/jpeg', 0.6);

      Api.postImage(postImage).then(function (result) {

        vm.loading = false;
        vm.showCanvas = true;

        // $log.log(result.statusText);
        // $log.log(result);

        if (result.status == 200) {

            // scoped properties to be used in our stranger canvas directive
            vm.success = true;
            vm.renderToCanvas = true;
            vm.userImage = imageToDisplay;
            vm.userText = result.data[0].description.toUpperCase();
            vm.imageLabels = result.data;

        } else {

          // $log.log(result);
          alert('Something went wrong :(');
          vm.success = false;

        }

      }).catch(function () {

        // quick fix to deal with cloud vision api rate limit
        // alert('This site is too busy right now :( Please try again, or come back later.');
        // $window.location.reload();

      });

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('evenstrangerthings')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('evenstrangerthings')
    .config(routeConfig);

  function routeConfig($routeProvider, $locationProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .otherwise({
        redirectTo: '/'
      });

    $locationProvider.html5Mode(true);
  }

})();

(function() {
  'use strict';

  angular
    .module('evenstrangerthings')

})();

(function() {
  'use strict';

  angular
    .module('evenstrangerthings')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  
  }

})();

angular.module("evenstrangerthings").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=lighting ng-class=\"{hide: main.showCanvas}\"><img src=/assets/images/lighting.png></div><div class=hero ng-class=\"{hide: main.showCanvas}\"><img src=/assets/images/even-stranger-things.svg></div><div class=desc ng-class=\"{hide: main.showCanvas}\"><img src=/assets/images/description.svg></div><spinner ng-show=!main.allAssetsLoaded></spinner><div class=upload ng-class=\"{hide: main.showCanvas}\" ngf-select=main.upload($file) ngf-accept=\"\'image/*\'\" ng-show=main.allAssetsLoaded><img class=tv src=assets/images/tv.png> <img class=upload-an-image src=assets/images/upload-an-image.png ng-hide=main.loading> <img class=glitch src=assets/images/loading.gif></div><div class=canvas-container ng-show=main.allAssetsLoaded ng-class=\"{show: main.showCanvas}\"><stranger-canvas render-to-canvas=main.renderToCanvas user-image=main.userImage user-text=main.userText display-width=main.displayWidth></stranger-canvas><img src=assets/images/canvas-placeholder.png class=no-pointer><show-image-labels render-to-canvas=main.renderToCanvas image-labels=main.imageLabels></show-image-labels><div class=share><img src=assets/images/go-again.png ng-click=main.goAgain()></div></div><div class=assets ng-show=main.allAssetsLoaded><img id=canvas-background src=assets/images/canvas-background.png> <img id=mask src=assets/images/mask.png> <img id=lighting-small src=assets/images/lighting-small.png></div>");
$templateCache.put("app/components/showImageLabels/showImageLabels.html","<div class=labels><span id=typewriter></span></div><!-- I saw: <span ng-repeat=\"label in vm.imageLabels\">{{label}}{{$last ? \'\' : \', \'}}</span> -->");
$templateCache.put("app/components/spinner/spinner.html","<div class=spinner><div>Loading</div><span class=\"line line-1\"></span> <span class=\"line line-2\"></span> <span class=\"line line-3\"></span> <span class=\"line line-4\"></span> <span class=\"line line-5\"></span> <span class=\"line line-6\"></span> <span class=\"line line-7\"></span> <span class=\"line line-8\"></span> <span class=\"line line-9\"></span></div>");
$templateCache.put("app/components/strangerCanvas/strangerCanvas.html","<canvas id=preview></canvas>");}]);